import React, { Component } from 'react';
import {
  isEmbargoPath,
  prepareInstitutionData,
  prepareStateData
} from '../Util/DataHelper';
import { StateTotals, TopInstitutions, AllInstitutions, StateHeader, NationalBenefits } from './StateComponents';
import { Disclaimer, ErrorMessage, ToolInfo } from "./SharedComponents";

const API_URL = 'https://isevt.nafsa.org/';

class StateReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      stateData: [],
      institutionalData: [],
      selectedState: null,
      selectedYear: null
    };
  }

  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const selectedState = params.get("state");
    const selectedYear = params.get("year");
    if (!selectedState) {
      this.setState({
        isLoaded: true,
        error: 'Please select a State to generate a Report For'
      });

      return;
    }
    if (!selectedYear) {
      this.setState({
        isLoaded: true,
        error: 'Please select a Year to generate a Report For'
      });

      return;
    }

    this.setState({
      selectedState: selectedState,
      selectedYear: selectedYear
    });

    fetch(API_URL + "getState?state=" + selectedState + "&year=" + selectedYear)
      .then(res => res.json())
      .then((result) => {
        let preparedStateData = prepareStateData(result);
        if (preparedStateData.length > 0) {
          this.setState({
            stateData: preparedStateData[0]
          });
        }
        this.setState({
          isLoaded: true,
        });
      })
      .catch((error) => {
        console.error('Error:', error);
        this.setState({
          isLoaded: false,
          error: error,
        });
      });

    fetch(API_URL + "getInstitutional?state=" + selectedState + "&year=" + selectedYear)
      .then(res => res.json())
      .then((result) => {
        this.setState({
          isLoaded: true,
          institutionalData: prepareInstitutionData(result)
        });
      })
      .catch((error) => {
        console.error('Error:', error);
        this.setState({
          isLoaded: false,
          error: error,
        });
      });
  }

  printPage() {
    window.print();
  }

  renderContent() {
    if (this.state.error) {
      return <ErrorMessage/>;
    }
    if (!this.state.isLoaded) {
      return <div>Loading...</div>;
    } else {
      let imageSrc = (process.env.NODE_ENV === 'production') ? '/sites/default/files/isev_images/states/' + this.state.selectedState + '00.png' : 'images/MD00.png';

      let backUrl = '/policy-and-advocacy/policy-resources/nafsa-international-student-economic-value-tool-v2'
      if (isEmbargoPath()) {
        backUrl = '/embargo' + backUrl
      }

      return (
        <div>
          <div className={this.state.institutionalData.length > 10 ? "print-page" : "print-page last-page"}>
            <StateHeader selectedState={this.state.selectedState}/>
            <div className="report-highlights">
              <div className="report-highlights-data">
                <div className="header"><i className="header-subtitle"><strong>Benefits</strong> from<br/><strong>International Students</strong></i></div>
                <StateTotals {...this.state}/>
              </div>
              <div className="report-highlights-image">
                <img src={`${imageSrc}`} alt="state-image"/>
              </div>
            </div>
            <TopInstitutions institutions={this.state.institutionalData.slice(0, 10)}/>
            <NationalBenefits selectedState={this.state.selectedState}/>
            <ToolInfo/>
            <Disclaimer/>
          </div>

          {this.state.institutionalData.length > 10 &&
            <AllInstitutions institutions={this.state.institutionalData}/>
          }
        </div>
      );
    }
  };

  render() {
    return (
      <div className="container state-report">
        {this.renderContent()}
      </div>
    )
  }
}

export default StateReport
